export const mopinionScript = `
    (function () {
        var id = '7AEqSjgueGREf6NL3vv1tueEpSgZnbJHYjLq70Vc';
        var js = document.createElement('script');
        js.setAttribute('type', 'text/javascript');
        js.setAttribute('src', '//deploy.mopinion.com/js/pastease.js');
        js.async = true;
        document.getElementsByTagName('head')[0].appendChild(js);
        var t = setInterval(function () {
            try {
                Pastease.load(id);
                clearInterval(t);
            } catch (e) {
            }
        }, 50);
    })();`;
